import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '../services';
import { UserType } from '@app/models';

@Injectable({ providedIn: 'root' })
export class AdministratorGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const user = this.accountService.userValue;

        if (!this.accountService.isLoggedIn() || !user) {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        if (user.user_type === UserType.DoItYourself) {
            return true;
        }

        this.router.navigate(['/settings']);
        return false;
    }
}
